module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    staticStyle: {
      "z-index": "12312312312312"
    },
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "appendToBody": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "d-modal",
    attrs: {
      "slot": "insertComponent",
      "id": "d-create-task-for-user"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [(_vm.isCreateNewEmploymentTitle) ? [_vm._v("Tilføj ny ansættelse")] : [_vm._v("Er det til vikarer?")]], 2), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle d-modal__header__close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [(_vm.isCreateNewEmploymentTitle) ? _c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Titel")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    ref: "title_input",
    staticClass: "d-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "d-label",
    staticStyle: {
      "margin": "0 1rem"
    }
  }, [_vm._v("Skal personale med denne ansættelse inkluderes i\n        vikarlønindberetningen?")]), _vm._v(" "), _c('div', {
    staticClass: "d-input-group d-input-group--toggler",
    class: {
      'd-input-group--toggler--active': _vm.isManualSalary
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('setIsManualSalary', !_vm.isManualSalary)
      }
    }
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Skal indberettes som vikarløn\n        ")]), _vm._v(" "), _c('AppToggle', {
    attrs: {
      "allowChanges": false,
      "propOn": _vm.isManualSalary
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons"
  }, [_c('div', [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), (!_vm.isValid) ? _c('button', {
    staticClass: "do-bttn do-bttn--submit do-bttn--submit--disabled"
  }, [_vm._v("\n          Tilføj til " + _vm._s(_vm.selectedUsers.length) + " " + _vm._s(_vm.selectedUsers.length === 1 ? 'person' : 'personer') + "\n        ")]) : _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("\n          Tilføj til " + _vm._s(_vm.selectedUsers.length) + " " + _vm._s(_vm.selectedUsers.length === 1 ? 'person' : 'personer') + "\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-645d57ba!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/SalarySettings/SalarySettingsCreateEmploymentType.vue
// module id = 1964
// module chunks = 1